import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import { styled } from "@mui/material/styles";
import { Box, TableCell, TableRow, Typography } from "@mui/material";
import LinkToolTip from "../../common/components/LinkToolTip";
import { ResultRecord, TableHeader } from "../../interfaces";
import MultiHeaderTable from "../MultiHeaderTable/MultiHeaderTable";

const PREFIX = "BankFindInstitutionProfile";

const classes = {
  multiHeaderTableInstProfile: `${PREFIX}-multiHeaderTableInstProfile`,
};

const StyledBox = styled(Box)(() => ({
  [`& .${classes.multiHeaderTableInstProfile}`]: {
    "& thead": {
      "& th, td": {
        textAlign: "left",
      },

      "& tbody": {
        "& tr": {
          "& td": {
            "&:first-child": {
              fontWeight: "bold",
              width: 600,
            },
          },
        },
        "& td": {
          textAlign: "left",
        },
      },
    },
  },
}));

interface Props {
  results: ResultRecord;
}

export default function BankFindInstitutionProfile({ results }: Props) {
  const tableHeadData = [
    { title: "Identifier Name (Hover for description)" },
    { title: "" },
    { title: "Identifier Value" },
  ];

  const tableBodyData = [
    {
      title: "FDIC Unique Number (UNINUM)",
      tooltipText:
        "Is a unique identifier assigned to an institution by the Federal Deposit Insurance Corporation (FDIC)",
      value: results.UNINUM,
    },
    {
      title: "FRB ID (RSS-ID)",
      tooltipText:
        "Is a unique identifier assigned to an institution by the Federal Reserve Board (FRB)",
      value: results.FED_RSSD,
    },
    {
      title: "FRB ID for Bank Holding Company (RSSDHCR)",
      tooltipText:
        "Is a unique identifier assigned to a top bank holding company (aka regulatory high holder) by the Federal Reserve Board (FRB)",
      value: results.RSSDHCR,
    },

    {
      title: "OCC Charter Number (CHARTER)",
      tooltipText:
        "Is a unique identifier assigned to an institution by the Office of the Comptroller of the Currency (OCC)",
      value: results.CHARTER,
    },
    {
      title: "Docket Number (DOCKET)",
      tooltipText:
        "Is a unique identifier assigned to an institution chartered by the Office of Thrift Supervision (OTS), or an institution that becomes a member of the Federal Home Loan System",
      value: results.DOCKET,
    },
    {
      title: "Legal Entity Identifier (LEI)",
      tooltipText:
        "A 20-digit alpha-numeric code that uniquely identifies entities that engage in financial transactions.",
      value: results.LEI,
    },
  ];
  const ProfileHeaders: TableHeader[][] = [
    tableHeadData.map((value: any) => ({
      title: value.title,
      colSpan: 1,
      styles: {},
    })),
  ];
  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(even)": {
      backgroundColor: theme.palette.action.hover,
    },
  }));
  const InstitutionProfileTable = () => {
    return (
      <div
        id="bankFindInstitutionProfile"
        className={classes.multiHeaderTableInstProfile}
      >
        <MultiHeaderTable
          tableHeaders={ProfileHeaders}
          tableBody={
            <>
              {tableBodyData.map((data, index) => {
                const tooltipPopper = (
                  <Box key={`popper-${index}`}>
                    <Typography variant="h4">{`${data.title}`}</Typography>
                    <Typography>{`${data.tooltipText}`}</Typography>
                  </Box>
                );

                return data.value && data.value !== "0" ? (
                  <StyledTableRow key={`row-${index}`} id={`row-${index}`}>
                    <TableCell
                      key={`title-${index}`}
                      id={`title-${index}`}
                      style={{
                        textAlign: "left",
                        width: 600,
                        fontWeight: "bold",
                      }}
                    >
                      {data.title}
                    </TableCell>
                    <TableCell
                      key={`info-${index}`}
                      id={`info-${index}`}
                      style={{ textAlign: "left" }}
                    >
                      <LinkToolTip
                        title={tooltipPopper}
                        enterDelay={250}
                        placement={"right"}
                        tabIndex={0}
                      >
                        <HelpOutlineOutlinedIcon
                          sx={{
                            cursor: "pointer",
                          }}
                        />
                      </LinkToolTip>
                    </TableCell>
                    <TableCell
                      key={`value-${index}`}
                      id={`value-${index}`}
                      style={{ textAlign: "left" }}
                    >
                      {data.value}
                    </TableCell>
                  </StyledTableRow>
                ) : undefined;
              })}
            </>
          }
        />
      </div>
    );
  };
  return (
    <StyledBox>
      <Typography variant="h4" style={{ paddingTop: 10 }}>
        Other Institution Identifiers used by Regulatory Agencies
      </Typography>
      <InstitutionProfileTable />
    </StyledBox>
  );
}
